import { render, staticRenderFns } from "./ActionsChat.vue?vue&type=template&id=14124b5a&scoped=true&"
import script from "./ActionsChat.vue?vue&type=script&lang=js&"
export * from "./ActionsChat.vue?vue&type=script&lang=js&"
import style0 from "./ActionsChat.vue?vue&type=style&index=0&id=14124b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14124b5a",
  null
  
)

export default component.exports